import Table from "src/components/Common/UI/DndTable/Table";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import Modal from "src/components/Common/UI/Modal/Modal";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import EditPhoneLine from "../../LinesAndNodesConfiguration/PhoneLine/EditPhoneLine";
import { usePhoneLinesTable } from "./hooks/usePhoneLinesTable";

const PhoneLinesTable = ({unitID}: PhoneLinesTableProps) => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    modalEvent
  } = usePhoneLinesTable({unitID: unitID});

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} />
  );

  return (
    <>
      <Table
        columns={columns}
        data={data}
        defaultOrderByKeyFilter={"id"}
        showNumberOfRows={false}
        rowSelection={true}
        setRowSelection={setSelectedRowsOfTable}
        multipleRowSelection={false}
        actionRowId={"id"}
        debugMode={false}
        noDataFoundTitle="No phone lines yet"
        isChangeOrderOrVisibilityEnable={false}
        ButtonsAreaLeft={ActionButtons}
        textPosition="center"
      />

      <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          size="xl"
          >
            {modalEvent.action === "edit" && <EditPhoneLine handleCloseModal={closeActionModal} phoneLineId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
            
        </Modal>

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default PhoneLinesTable;

interface PhoneLinesTableProps {
  unitID: number;
}